module.exports = __webpack_public_path__ + "img/I7.e296ecea.png";